import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { bookingsSelectors } from '~/api';

import { MemoizedBookingReview } from './BookingReview';

export const mapStateToProps = createStructuredSelector({
  dateSlot: bookingsSelectors.selectDateSlot,
  store: bookingsSelectors.selectStore,
});

export const ConnectedBookingReview = connect(mapStateToProps)(MemoizedBookingReview);
